export const getLayout = ({ layouts: { layouts } }, siteId) => layouts[siteId] || {};
export const getLayouts = (state) => state.layouts.layouts;
export const hasBeenUpdated = ({ layouts: { updatedLayouts } }, siteId) =>
  updatedLayouts.includes(siteId);
export const isImportedLayout = (state) => state.layouts.isImportingLayout;
